(function () {
    'use strict';

    angular
        .module('blocks.exception')
        .factory('exception', exception);

    exception.$inject = ['$q', 'logger'];
    /* @ngInject */
    function exception($q, logger) {
        var service = {
            catcher: catcher
        };
        return service;

        function catcher(message, suppressLogger) {
            return function (e) {
                var thrownDescription;
                var newMessage;
                if (e && e.data) {
                    if(e.data.description)
                    {
                        thrownDescription = '\n' + e.data.description;
                    }
                    else if (e.data.Message) {
                        thrownDescription = '\n' + e.data.Message;
                    }
                    else if (e.data.error_description) {
                        thrownDescription = '\n' + e.data.error_description;
                    }
                    else if (e.data.error) {
                        thrownDescription = '\n' + e.data.error;
                    }
                    newMessage = message + thrownDescription;
                    e.data.description = newMessage;
                }
                if (!suppressLogger) {
                    logger.error(newMessage || message);
                }
                return $q.reject(e);
            };
        }

        
    }
})();
